import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import * as S from './styles'
import { IProps } from './types'

export const Button: React.FC<IProps> = ({
    children,
    icon,
    color,
    btnRef,
    ...props
}: IProps) => {
    
    const Button = S.StyledButton(color, props);
    return (
        <Button ref={btnRef}>
            {
                !!icon && <FontAwesomeIcon icon={icon} className="pr-1"/>
            }
            {children}
        </Button>
    )
}
